import React, { useEffect, useRef, useState } from "react";
import Breadcrumb from "../../common/BreadCrumb";
import CVIcon from "./cv_icon";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import { fetchUserCvs } from "../../../states/actions/jobAlerts";
import DownloadCv from "../../common/downloadCv";
import EditCvPopup from "../../common/edit-cv-popup";
import { getAuthUserToken } from "../../../helpers/authToken";
import http from "../../../helpers/http";
import { doObjToFormData } from "../../../helpers/helpers";
import { toast, ToastContainer } from "react-toastify";
import { TOAST_SETTINGS } from "../../../utils/siteSettings";
import Text from "../../common/Text";
import LoaderSpinner from "../../common/LoaderSpinner";

const MyCVs = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchJobAlerts.content);
  const isLoading = useSelector((state) => state.fetchJobAlerts.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );
  //   const { content } = data;

  useEffect(() => {
    dispatch(fetchUserCvs());
  }, []);

  useDocumentTitle(data.page_title);
  const breadcrumbItems = [
    { name: "Dashboard", link: "/dashboard" },
    { name: "My CVs", link: "/my-cvs" },
  ];

  const items = data?.cvs?.map((cv, index) => {
    const details = cv.cv_details;

    return {
      id: cv.id, // or index + 1 if you prefer sequential numbers
      title: `${details.current_title} CV`,
      created: new Date(cv.created_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
      tags: [
        { label: "Optimized", color: "green" },
        { label: `ATS Score: ${details.job_match_score}%`, color: "blue" },
      ],
      description: [
        `Tailored for: ${details.current_title} at ${
          details.work_experience?.[0]?.company || "Company"
        }`,
      ],
      cv_details: details,
    };
  });

  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleDropdown = (index) => {
    setActiveDropdown((prev) => (prev === index ? null : index));
  };

  const dropdownRefs = useRef({});
  const [itemsState, setItemsState] = useState([]); // store cv list locally

  useEffect(() => {
    if (data?.cvs) {
      const mappedItems = data.cvs.map((cv) => {
        const details = cv.cv_details;
        return {
          id: cv.id,
          title: `${details.current_title} CV`,
          created: new Date(cv.created_date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
          tags: [
            { label: "Optimized", color: "green" },
            { label: `ATS Score: ${details.job_match_score}%`, color: "blue" },
          ],
          description: [
            `Tailored for: ${details.current_title} at ${
              details.work_experience?.[0]?.company || "Company"
            }`,
          ],
          cv_details: details,
        };
      });
      setItemsState(mappedItems);
    }
  }, [data]); // update whenever data changes

  useEffect(() => {
    const handleClickOutside = (event) => {
      // check all dropdown refs
      const isClickInside = Object.values(dropdownRefs.current).some(
        (ref) => ref && ref.contains(event.target)
      );

      if (!isClickInside) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  //   console.log("data",data)
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [selectedCv, setSelectedCv] = useState(null);

  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const handleDelete = (cv_id) => {
    const formData = {
      token: getAuthUserToken(),
      cv_id: cv_id,
    };
    setIsDeleting(true);

    http
      .post("user/delete-cv", doObjToFormData(formData))
      .then(({ data }) => {
        setIsDeleting(false);
        if (data.status) {
          toast.success("CV deleted Successfully");

          // 🔥 Remove the deleted CV from local state
          setItemsState((prev) => prev.filter((item) => item.id !== cv_id));
        } else if (data.validationErrors) {
          toast.error(
            <Text string={data.validationErrors} parse={true} />,
            TOAST_SETTINGS
          );
        }
      })
      .catch((error) => {
        setIsDeleting(false);
        console.log("Delete CV Error:", error);
      });
  };

  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <section id="dash">
          <Breadcrumb items={breadcrumbItems} />
          <ToastContainer />
          <div className="contain">
            <div className="dash_new_txt text-center">
              <h3>📄 My CVs</h3>
              <p>Manage and organize all your saved CVs</p>
            </div>
            <div className="outer_cmn_blk_dash all_cv_blk">
              <div className="cmn_blk_new_dash relative_pos">
                {isDeleting ? (
                  <div className="loading_overlay">
                    <LoaderSpinner />
                  </div>
                ) : null}
                <div className="top_head">
                  <h4 className="heading_dash">
                    Saved CVs{" "}
                    <span className="badge">
                      {`${
                        itemsState?.length == 1
                          ? "1 CV"
                          : itemsState?.length + " CVs"
                      }`}{" "}
                    </span>
                  </h4>
                </div>
                {/* <div className="flex all_cv_blk_flex">
                  {itemsState &&
                    itemsState.map((cv) => (
                      <div className="col" key={cv.id}>
                        {showEditPopup && (
                          <EditCvPopup
                            handleClose={() => setShowEditPopup(false)}
                            cvDetails={cv?.cv_details}
                            cv_id={cv.id}
                          />
                        )}

                        <div className="inner">
                          <div className="cv_head_col">
                            <div className="image_icon">
                              <CVIcon size={13} />
                            </div>
                            <div className="r_txt">
                              <h5 className="heading_dash">{cv.title}</h5>
                              <p>Created: {cv.created}</p>
                            </div>
                          </div>
                          <div className="action_btns">
                            <button
                              type="button"
                              className="edit_btn"
                              onClick={() => {
                                setSelectedCv(cv);
                                setShowEditPopup(true);
                              }}
                            >
                              <img
                                src="/images/cv-generator/icon_edit.svg"
                                alt="Edit"
                              />
                            </button>
                            <div
                              className="action_drop"
                              ref={(el) => (dropdownRefs.current[cv.id] = el)}
                            >
                              <button
                                type="button"
                                className="drop_btn"
                                onClick={() => toggleDropdown(cv.id)}
                              >
                                <img
                                  src="/images/cv-generator/dots.svg"
                                  alt="Actions"
                                />
                              </button>
                              <div
                                className={`drop_list ${
                                  activeDropdown === cv.id ? "active" : ""
                                }`}
                              >
                                <a
                                  href="#!"
                                  onClick={() => handleDelete(cv.id)}
                                >
                                  Delete
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="bdy_view_cv">
                            <div className="tags_bdy">
                              {cv.tags.map((tag, idx) => (
                                <span
                                  key={idx}
                                  className={`badge ${tag.color}`}
                                >
                                  {tag.label}
                                </span>
                              ))}
                            </div>
                            <ul>
                              {cv.description.map((detail, idx) => (
                                <li key={idx}>{detail}</li>
                              ))}
                            </ul>
                            <div className="btn_blk">
                              <DownloadCv
                                cv_id={cv.id}
                                className="site_btn"
                                btn_title="Download"
                              />
                              <DownloadCv cv_id={cv.id} is_preview={true} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  <div className="col upload_cv_col">
                    <div className="inner">
                      <div className="img_icon">
                        <img src="/images/cv-generator/plus.svg" alt="" />
                      </div>
                      <h5>Create New CV</h5>
                      <p>
                        <small>
                          Generate a tailored CV for your next job application
                        </small>
                      </p>
                      <div className="btn_blk">
                        <Link to="/cv-generator" className="site_btn sm">
                          Get Started
                        </Link>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="flex all_cv_blk_flex">
                  {itemsState &&
                    itemsState.map((cv) => (
                      <div className="col" key={cv.id}>
                        <div className="inner same_u_gap">
                          <div className="cv_head_col">
                            <div className="image_icon">
                              <CVIcon size={13} />
                            </div>
                            <div className="r_txt">
                              <h5 className="heading_dash">{cv.title}</h5>
                              <p>Created: {cv.created}</p>
                            </div>
                          </div>
                          <div className="action_btns">
                            <button
                              type="button"
                              className="edit_btn"
                              onClick={() => {
                                setSelectedCv(cv);
                                setShowEditPopup(true);
                              }}
                            >
                              <img
                                src="/images/cv-generator/icon_edit.svg"
                                alt="Edit"
                              />
                            </button>
                            <div
                              className="action_drop"
                              ref={(el) => (dropdownRefs.current[cv.id] = el)}
                            >
                              <button
                                type="button"
                                className="drop_btn"
                                onClick={() => toggleDropdown(cv.id)}
                              >
                                <img
                                  src="/images/cv-generator/dots.svg"
                                  alt="Actions"
                                />
                              </button>
                              <div
                                className={`drop_list ${
                                  activeDropdown === cv.id ? "active" : ""
                                }`}
                              >
                                <a
                                  href="#!"
                                  onClick={() => handleDelete(cv.id)}
                                >
                                  Delete
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="bdy_view_cv">
                            <div className="tags_bdy">
                              {cv.tags.map((tag, idx) => (
                                <span
                                  key={idx}
                                  className={`badge ${tag.color}`}
                                >
                                  {tag.label}
                                </span>
                              ))}
                            </div>
                            <ul>
                              {cv.description.map((detail, idx) => (
                                <li key={idx}>{detail}</li>
                              ))}
                            </ul>
                            <div className="btn_blk">
                              <DownloadCv
                                cv_id={cv.id}
                                className="site_btn"
                                btn_title="Download"
                              />
                              <DownloadCv cv_id={cv.id} is_preview={true} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  <div className="col upload_cv_col">
                    <div className="inner">
                      <div className="img_icon">
                        <img src="/images/cv-generator/plus.svg" alt="" />
                      </div>
                      <h5>Create New CV</h5>
                      <p>
                        <small>
                          Generate a tailored CV for your next job application
                        </small>
                      </p>
                      <div className="btn_blk">
                        <Link to="/cv-generator" className="site_btn sm">
                          Get Started
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                {showEditPopup && selectedCv && (
                  <EditCvPopup
                    handleClose={() => setShowEditPopup(false)}
                    cvDetails={selectedCv.cv_details}
                    cv_id={selectedCv.id}
                    onSuccess={() => window.location.reload()}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default MyCVs;
